import { LoadingSpinner, Modal } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

interface Props {
  onClose: () => void
}

export const LoadingModal = ({ onClose }: Props) => {
  const { t } = useTranslation("Payroll")

  return (
    <Modal isOpen onRequestClose={onClose}>
      <Modal.Header>{t("modal.title")}</Modal.Header>
      <Modal.Content className="flex justify-center">
        <LoadingSpinner />
      </Modal.Content>
    </Modal>
  )
}
